import { defineMessages } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Ball } from '@sorare/core/src/atoms/icons/Ball';
import { Bell } from '@sorare/core/src/atoms/icons/Bell';
import { iconGavel } from '@sorare/core/src/atoms/icons/system/iconGavel.ts';
import { DownloadApp } from '@sorare/core/src/components/DownloadApp';

type Props = { open: boolean; onClose: (doNotShowAgain: boolean) => void };

const messages = defineMessages({
  alertsOnOffers: {
    defaultMessage: 'Alerts on Offers',
  },
  alertsOnAuctions: {
    defaultMessage: 'Alerts on Auctions',
  },
  livePerformanceUpdates: {
    defaultMessage: 'Live Performance Updates',
  },
});

const AlertsOnAuctions = ({
  width,
  height,
}: {
  width: number;
  height: number;
}) => {
  return <FontAwesomeIcon icon={iconGavel} width={width} height={height} />;
};

const benefits = [
  {
    id: 'alerts-on-offers',
    icon: <Bell width={16} height={16} />,
    label: messages.alertsOnOffers,
  },
  {
    id: 'alerts-on-auctions',
    icon: <AlertsOnAuctions width={16} height={16} />,
    label: messages.alertsOnAuctions,
  },
  {
    id: 'live-performance-updates',
    icon: <Ball size={2} />,
    label: messages.livePerformanceUpdates,
  },
];

export const AddReminderDownloadApp = ({ open, onClose }: Props) => {
  return <DownloadApp open={open} onClose={onClose} benefits={benefits} />;
};
